// extracted by mini-css-extract-plugin
module.exports = {"root":"MoreByDesigner_root__IDem3","loadMore":"MoreByDesigner_loadMore__KEXxR"};